import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";

Vue.use(Vuex);

const load_and_preserve = (state, list, property) => {
  if (state[list].length) {
    const preserved = state[list].filter(c => c._id == state[property]._id);
    if (preserved.length) {
      state[property] = preserved[0];
    } else {
      state[property] = state[list][0];
    }
  } else {
    state[property] = null;
    return;
  }
}
const employee_sort = function (e1, e2) {
  return ("" + e1.code).localeCompare(e2.code);
}

export default new Vuex.Store({
  state: {
    bus: new Vue(),
    user: null,
    tasks: [],
    crew: null,
    crews: [],
    company: null,
    companies: [],
    available_members: [],
    available_leaders: [],
    tasks: []
  },
  getters: {

  },
  methods: {},
  actions: {

  },
  mutations: {
    tasks(state, tasks) {
      state.tasks = tasks;
    },
    available_members(state, available) {
      state.available_members = available;
    },
    available_leaders(state, available) {
      state.available_leaders = available;
    },
    refresh(state, payload) {
      // Called when a user clicks the refresh button.
      // Only replace the company list - then make sure the old company
      // is still there.  If so, then move on to the crew, then member.
      // If company, crew, or member is not present in the new list, default to first one.
      state.companies = payload.companies.filter(c => c.crews && c.crews.length > 0);
      load_and_preserve(state, 'companies', 'company');
      if (state.company) {
        state.crews = state.company.crews;
        load_and_preserve(state, 'crews', 'crew');
      }

      state.bus.$emit("crew");

    },
    login(state, user) {
      if (!user) {
        state.user = null;
        state.companies = [];
        state.company = null;
        state.crew = null;
        return;
      }
      state.user = user.user;

      // Company initialization
      state.companies = user.companies.filter(c => c.crews && c.crews.length > 0);
      state.company = state.companies.length ? state.companies[0] : null;
      if (state.companies.length > 0) {
        state.company = state.companies[0];
      } else {
        return;
      }

      // Crew initialization
      state.crews = state.company.crews;
      if (state.company.crews.length > 0) {
        state.crew = state.company.crews[0];
        state.bus.$emit("crew");
      } else {
        return;
      }
    },
    company(state, company) {
      state.company = company;
      if (company) {
        state.crews = state.company.crews;
        state.crew = null;
        if (state.company.crews.length > 0) {
          state.crew = state.company.crews[0];
          state.bus.$emit("crew");
        } else {
          return;
        }
      }
    },
    crew(state, crew) {
      state.crew = crew;
      state.bus.$emit("crew");
    },
    membership(state, membership) {

    }
  },
  modules: {}
});
